/**
 * @generated SignedSource<<28292efa0c5b62494154f78d792b5cc7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contractId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nickName"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "npi"
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FacilityMutationGroup",
    "kind": "LinkedField",
    "name": "facility",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "legalContractId",
                "variableName": "contractId"
              },
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "name"
              },
              {
                "kind": "Variable",
                "name": "nickName",
                "variableName": "nickName"
              },
              {
                "kind": "Variable",
                "name": "npi",
                "variableName": "npi"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "FacilityModifyPayload",
        "kind": "LinkedField",
        "name": "create",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Facility",
            "kind": "LinkedField",
            "name": "facility",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewFacilityModalMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "NewFacilityModalMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "3e5613b7c2b9be0128f882dda1f70b20",
    "id": null,
    "metadata": {},
    "name": "NewFacilityModalMutation",
    "operationKind": "mutation",
    "text": "mutation NewFacilityModalMutation(\n  $contractId: ID!\n  $name: String!\n  $npi: String!\n  $nickName: String!\n) {\n  facility {\n    create(input: {legalContractId: $contractId, name: $name, nickName: $nickName, npi: $npi}) {\n      facility {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "aed263bf8cfd4ec7124022fd426b3a95";

export default node;
